import { GaOptions } from 'react-ga';

import { PaypalEnv } from '../billing/paypal';

type DashboardConfig = {
  ogcServiceBasePath: string;
  identityServiceBasePath: string;
  wmsConfigurationServiceBasePath: string;
  rateLimitSupervisorServiceBasePath: string;
  dashboardServiceBasePath: string;
  byocGlobalServiceBasePath: string;
  byocEuCentralServiceBasePath?: string;
  byocUsWestServiceBasePath?: string;
  byocSgsHqServiceBasePath?: string;
  byocMundiServiceBasePath?: string;
  byocCreodiasServiceBasePath?: string;
  byocCodeDeServiceBasePath?: string;
  tpdiServiceBasePath: string;
  redirect: string;
  clientId: string;
  codeDEClientId: string;
  codeDEUrl: string;
  creoClientId: string;
  creoUrl: string;
  mundiClientId: string;
  mundiUrl: string;
  usWestWmsServiceBasePath: string;
  creodiasWmsServiceBasePath: string;
  sinergiseTemplateUserId: string;
  sinergiseTemplateDomainId: string;
  codeDeTemplateUserId: string;
  codeDeTemplateDomainId: string;
  creodiasTemplateUserId: string;
  creodiasTemplateDomainId: string;
  playgroundAppBaseUrl: string;
  paypalEnv: PaypalEnv;
  adyenEnvironment: 'test' | 'live';
  adyenClientId: string;
  sentry: SentryConfig;
  googleAnalytics: GoogleAnalyticsConfig;
  byocEnabled?: boolean;
};

type SentryConfig = {
  dsn: string;
  env: string;
  enable: boolean;
};

type GoogleAnalyticsConfig = {
  trackingID: string;
  enable: boolean;
  options: GaOptions;
};

export const CONFIG: DashboardConfig = require(`../../../environments/${process.env.REACT_APP_ENV}.json`);
